window.tradeInPropertyUtils = (() => {
  const tradeInMap = {
    tradeInValue: "_tradeIn_value",
    tradeInDevice: "_tradeIn_device",
    tradeInEvaluationId: "_tradeIn_evaluationId",
    tradeInExpiresAt: "_tradeIn_expiresAt",
    tradeInExpired: "_tradeIn_expired",
    tradeInType: "_tradeIn_type",
    tradeInError: "_tradeIn_error",
  };
  const tradeInKeys = Object.values(tradeInMap);

  function getTradeIn($lineItem) {
    const tradeInProperties = {};

    Object.entries(tradeInMap).forEach(([dataKey, propertyKey]) => {
      const propertyValue = $lineItem?.data(dataKey);
      if (propertyValue !== undefined && propertyValue !== "") {
        tradeInProperties[propertyKey] = propertyValue;
      }
    });

    return tradeInProperties;
  }

  function appendTradeIn(properties, tradeInProperties = {}) {
    Object.entries(tradeInProperties).forEach(([propertyKey, propertyValue]) => {
      const normalizedValue = propertyValue;
      if (normalizedValue !== undefined && normalizedValue !== "") {
        properties[propertyKey] = normalizedValue;
      }
    });

    return properties;
  }

  return {
    tradeInMap,
    tradeInKeys,
    getTradeIn,
    appendTradeIn,
  };
})();
